<template>
  <div>
    <v-tabs
      active-class="primary--text"
      :height="INTERVENTIONS_TABS_HEIGHT"
      :background-color="$vuetify.theme.themes[theme].background"
      v-model="tab"
      grow
      show-arrows
    >
      <v-tab>
        <button-icon
          icon="mdi-run"
          label="En cours"
          :active="tab === 0"
          :badge="displayed[0] ? '!' : null"
        />
      </v-tab>
      <v-tab>
        <button-icon
          icon="mdi-calendar-arrow-right"
          label="Planifiée"
          :active="tab === 1"
          :badge="displayed[1] ? '!' : null"
        />
      </v-tab>
      <v-tab>
        <button-icon
          icon="mdi-calendar-clock"
          label="Historique"
          :active="tab === 2"
          :badge="displayed[2] ? '!' : null"
        />
      </v-tab>
    </v-tabs>
    <v-tabs-items
      :style="{
        background: $vuetify.theme.themes[theme].background,
      }"
      v-model="tab"
    >
      <v-tab-item>
        <interventions-data-table namespace="properties/interventions" />
      </v-tab-item>
      <v-tab-item>
        <interventions-data-table
          namespace="properties/interventions/planned"
          planned
        />
      </v-tab-item>
      <v-tab-item>
        <history-filters
          :style="`height: ${HISTORY_FILTERS_HEIGHT}px`"
          class="overflow-y-auto"
          ref="filters"
        />
        <history-data-table />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';
import ButtonIcon from '@/pages/FRI/ButtonIcon';
import {
  HISTORY_FILTERS_HEIGHT,
  INTERVENTIONS_TABS_HEIGHT,
} from '@/pages/eDispatch/requestDetails/rightSide/requestsRightSide';
import InterventionsDataTable from './InterventionsDataTable';
import HistoryDataTable from './HistoryDataTable';
import HistoryFilters from './HistoryFilters';

export default {
  name: 'PropertyInterventions',
  components: {
    InterventionsDataTable,
    HistoryDataTable,
    HistoryFilters,
    ButtonIcon,
  },
  computed: {
    ...mapGetters({
      isLoadingInterventions: 'properties/interventions/isLoadingItems',
      interventionsData: 'properties/interventions/items',
      isLoadingPlannedInterventions:
        'properties/interventions/planned/isLoadingItems',
      plannedInterventionsData: 'properties/interventions/planned/items',
      isLoadingDetails: 'properties_360/isLoadingCurrent',
    }),
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
  watch: {
    tab(value) {
      this.displayed[value] = false;
    },
    isLoadingInterventions(value) {
      if (!value && this.isFirstLoading[0]) {
        this.onInterventionsLoaded();
      }
    },
    isLoadingPlannedInterventions(value) {
      if (!value && this.isFirstLoading[1]) {
        this.onPlannedInterventionsLoaded();
      }
    },
    isLoadingDetails(value) {
      if (value) {
        this.displayed = [false, false, false];
        this.tab = 0;
        this.isFirstLoading = [true, true];
      }
    },
  },
  methods: {
    generateMessage,
    updateDisplayed(index, value) {
      const tmp = [...this.displayed];
      tmp[index] = value;
      this.displayed = tmp;
    },
    onInterventionsLoaded() {
      this.isFirstLoading[0] = false;
      if (this.interventionsData.length && this.tab !== 0) {
        this.updateDisplayed(0, true);
      } else if (!this.interventionsData.length && this.tab === 0) {
        if (
          !this.isLoadingPlannedInterventions &&
          !this.plannedInterventionsData.length
        ) {
          this.tab = 2;
        } else {
          this.tab = 1;
        }
      }
    },
    onPlannedInterventionsLoaded() {
      this.isFirstLoading[1] = false;
      if (this.tab !== 1 && this.plannedInterventionsData.length) {
        this.updateDisplayed(1, true);
      } else if (this.tab === 1 && !this.plannedInterventionsData.length) {
        this.tab = 2;
      }
    },
  },
  mounted() {
    if (!this.isLoadingInterventions) {
      this.onInterventionsLoaded();
    }
    if (!this.isLoadingPlannedInterventions) {
      this.onPlannedInterventionsLoaded();
    }
  },
  data: () => ({
    tab: 0,
    displayed: [false, false, false],
    isFirstLoading: [true, true],
    INTERVENTIONS_TABS_HEIGHT,
    HISTORY_FILTERS_HEIGHT,
  }),
};
</script>
